import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { useSelector, useDispatch } from 'react-redux';
import 'react-accessible-accordion/dist/fancy-example.css';
import { MenuItem, FormControl, Select, } from '@mui/material';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, } from 'react-accessible-accordion';

import Checkbox from '@mui/material/Checkbox';
import AllActivities from '../SinglePage/AllActivities.js';
import { updateObject } from '../../store/Objects/index.js';
import ActivityCard from '../SinglePage/ActivityCard/index.js';
import { setActiveActivityBox } from '../../store/Activities/index.js';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import PropertyField from '../../components/Properties/PropertyField.js';
import CircleCheckedFilled from '@mui/icons-material/CheckCircleOutline';
import { getSinglePageData, updateSinglePageField, clearSinglePageData, setLoading } from '../../store/SinglePage';
import TableAnimationFiles from '../../components/Animations/TableAnimationFiles.js';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other} >
      {value === index && (<Box p={3}> <Typography>{children}</Typography> </Box>)}
    </div>
  );
}

TabPanel.propTypes = { children: PropTypes.node, index: PropTypes.any['isRequired'], value: PropTypes.any['isRequired'] };


const ViewModal = ({ dealData, setIsSideViewModal }) => {
  const dispatch = useDispatch();
  let { currentWorkspace } = useSelector(state => state['Settings']);
  let { singlePageData, isLoading: loading } = useSelector(state => state['SinglePage']);

  let [dropdowns, setDropdowns] = useState({});
  let [dealOwner, setDealOwner] = useState('');
  const toggleDropdownAction = (id) => setDropdowns((prev) => ({ ...prev, [id]: !prev[id] }));

  const [valueCustomVoiceTab, setValueCustomVoiceTab] = useState(0);
  const handleTabsSetCustomVoice = (e, valueCustomVoiceTab) => setValueCustomVoiceTab(valueCustomVoiceTab);

  // Pagination states
  const [upcomingPage, setUpcomingPage] = useState(1);
  const [allActivitiesPage, setAllActivitiesPage] = useState(1);
  const itemsPerPage = 10;

  // Close modal on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsSideViewModal(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [setIsSideViewModal]);

  // Clear previous data and fetch new deal data when modal opens
  useEffect(() => {
    if (dealData && dealData._id) {
      dispatch(clearSinglePageData());
      dispatch(setLoading(true));
      dispatch(getSinglePageData({ objectType: 'deals', id: dealData._id }));
    }
  }, [dealData?._id, dispatch]);

  // Get properties from singlePageData
  const properties = singlePageData?.properties || {};

  // Get property configuration from store
  const getPropertyConfig = (propertyKey) => {
    for (const group of Object.values(properties)) {
      if (Array.isArray(group)) {
        const prop = group.find(p => p['name'] === propertyKey);
        if (prop) return prop;
      }
    }
    return null;
  };

  // Get property value
  const getPropertyValue = (propertyKey) => {
    const config = getPropertyConfig(propertyKey);
    if (config && config['isSystem'] === false) {
      return singlePageData?.['customFields']?.[propertyKey];
    }
    return singlePageData?.[propertyKey] || '';
  };

  // Get properties that should be shown in About section
  const getAboutProperties = () => {
    const aboutProperties = [];
    for (const group of Object.values(properties)) {
      if (Array.isArray(group)) {
        const propsToShow = group.filter(prop => prop['displayConfig']?.['showInAbout'] === true);
        aboutProperties.push(...propsToShow);
      }
    }
    return aboutProperties.sort((a, b) => (a['order'] || 1000) - (b['order'] || 1000));
  };

  // Render property based on type
  const renderPropertyField = (propertyKey) => {
    const value = getPropertyValue(propertyKey);
    const config = getPropertyConfig(propertyKey);
    if (!config) return null;

    return (
      <PropertyField
        library='mui'
        mode='display'
        value={value}
        property={config}
        objectType='deals'
        objectId={dealData?._id}
        editable={!config['displayConfig']?.['readOnly']}
        onChange={(fieldName, newValue) => {
          let updateData;
          if (config['isSystem'] === false) {
            updateData = {
              customFields: {
                ...singlePageData?.['customFields'],
                [fieldName]: newValue
              }
            };
          } else updateData = { [fieldName]: newValue };
          dispatch(updateSinglePageField(updateData));

          if (config['type'] === 'multiselect') return;

          const dataToSave = config['type'] === 'user' && typeof newValue === 'object' ? newValue['_id'] : newValue;
          let backendData;
          if (config['isSystem'] === false) backendData = { customFields: { ...singlePageData?.['customFields'], [fieldName]: dataToSave } };
          else backendData = { [fieldName]: dataToSave };


          dispatch(updateObject({ id: dealData?._id, data: backendData, objectType: 'deals' }));
        }}
        onSave={(fieldName, newValue, needRefresh) => {
          if (needRefresh) dispatch(getSinglePageData({ id: dealData?._id, objectType: 'deals' }));
        }}
        additionalData={{ users: currentWorkspace?.['members'] || [] }}
      />
    );
  };

  // Render all mapped properties
  const renderAboutProperties = () => {
    const aboutProperties = getAboutProperties();
    if (aboutProperties.length === 0) return <p className="no-properties">No properties to display</p>;
    return aboutProperties.map(prop => (
      <div key={prop['name']} className="property-item">
        {renderPropertyField(prop['name'])}
      </div>
    ));
  };

  return (
    <aside className="deal-sidebar style-view-sidebar accordian-tabs-area" onClick={(e) => e.stopPropagation()}>
      <div className='top-header-area'>
        <h4>{dealData?.title || 'Deal Details'}</h4>
        <button className='close-btn-area' onClick={() => setIsSideViewModal(false)}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_1678_4872" fill="white">
              <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" />
            </mask>
            <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" fill="var(--primary-color)" />
            <path d="M8.21204 0.303865L7.94019 0.0318008L7.94012 0.0318703L8.21204 0.303865ZM9.69251 0.303865L9.96446 0.0319116L9.96443 0.0318845L9.69251 0.303865ZM6.47962 4.9982L6.20766 4.72625L5.93571 4.9982L6.20766 5.27015L6.47962 4.9982ZM9.69251 9.69254L9.96444 9.96451L9.96446 9.96449L9.69251 9.69254ZM8.95227 10.0002V10.3848H8.95235L8.95227 10.0002ZM8.21204 9.69254L7.94008 9.96449L7.94018 9.96459L8.21204 9.69254ZM4.99817 6.47867L5.27012 6.20672L4.99813 5.93472L4.72617 6.20676L4.99817 6.47867ZM1.78528 9.69254L1.51312 9.42046L1.50411 9.43012L1.78528 9.69254ZM1.04504 10.0002V10.3848H1.04522L1.04504 10.0002ZM0.303834 9.69254L0.0318532 9.96446L0.0318803 9.96449L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L0.303834 8.21109ZM3.51672 4.9982L3.78868 5.27015L4.06063 4.9982L3.78868 4.72625L3.51672 4.9982ZM0.303834 0.303865L0.0318803 0.0319116L0.0318571 0.0319349L0.303834 0.303865ZM4.99817 3.51676L4.72622 3.78871L4.99813 4.06062L5.27008 3.78875L4.99817 3.51676ZM8.21204 0.303865L8.48388 0.575929C8.73895 0.321065 9.16579 0.321107 9.42058 0.575846L9.69251 0.303865L9.96443 0.0318845C9.4091 -0.523338 8.49544 -0.522995 7.94019 0.0318008L8.21204 0.303865ZM9.69251 0.303865L9.42055 0.575819C9.67551 0.830776 9.67551 1.2584 9.42055 1.51336L9.69251 1.78531L9.96446 2.05726C10.5198 1.50191 10.5198 0.587261 9.96446 0.0319116L9.69251 0.303865ZM9.69251 1.78531L9.42055 1.51336L6.20766 4.72625L6.47962 4.9982L6.75157 5.27015L9.96446 2.05726L9.69251 1.78531ZM6.47962 4.9982L6.20766 5.27015L9.42055 8.48305L9.69251 8.21109L9.96446 7.93914L6.75157 4.72625L6.47962 4.9982ZM9.69251 8.21109L9.42055 8.48305C9.67551 8.738 9.67551 9.16563 9.42055 9.42058L9.69251 9.69254L9.96446 9.96449C10.5198 9.40914 10.5198 8.49449 9.96446 7.93914L9.69251 8.21109ZM9.69251 9.69254L9.42057 9.42056C9.28679 9.55432 9.12078 9.61552 8.95219 9.61555L8.95227 10.0002L8.95235 10.3848C9.31445 10.3847 9.67923 10.2497 9.96444 9.96451L9.69251 9.69254ZM8.95227 10.0002V9.61555C8.7839 9.61555 8.61783 9.55432 8.48389 9.42048L8.21204 9.69254L7.94018 9.96459C8.22528 10.2495 8.58999 10.3848 8.95227 10.3848V10.0002ZM8.21204 9.69254L8.48399 9.42058L5.27012 6.20672L4.99817 6.47867L4.72622 6.75062L7.94008 9.96449L8.21204 9.69254ZM4.99817 6.47867L4.72617 6.20676L1.51328 9.42062L1.78528 9.69254L2.05727 9.96445L5.27016 6.75058L4.99817 6.47867ZM1.78528 9.69254L1.50411 9.43012C1.39292 9.54926 1.22188 9.61548 1.04487 9.61555L1.04504 10.0002L1.04522 10.3848C1.39881 10.3846 1.78669 10.2547 2.06644 9.95496L1.78528 9.69254ZM1.04504 10.0002V9.61555C0.876053 9.61555 0.709392 9.55419 0.575787 9.42058L0.303834 9.69254L0.0318803 9.96449C0.3174 10.25 0.683146 10.3848 1.04504 10.3848V10.0002ZM0.303834 9.69254L0.575814 9.42061C0.320867 9.16561 0.320881 8.73795 0.575787 8.48305L0.303834 8.21109L0.0318803 7.93914C-0.523471 8.49449 -0.52336 9.40914 0.0318532 9.96446L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L3.78868 5.27015L3.51672 4.9982L3.24477 4.72625L0.0318803 7.93914L0.303834 8.21109ZM3.51672 4.9982L3.78868 4.72625L0.575787 1.51336L0.303834 1.78531L0.0318803 2.05726L3.24477 5.27015L3.51672 4.9982ZM0.303834 1.78531L0.575787 1.51336C0.320873 1.25844 0.320862 0.830788 0.57581 0.575795L0.303834 0.303865L0.0318571 0.0319349C-0.523376 0.587263 -0.523471 1.50191 0.0318803 2.05726L0.303834 1.78531ZM0.303834 0.303865L0.575787 0.575819C0.830745 0.320861 1.25837 0.320861 1.51333 0.575819L1.78528 0.303865L2.05723 0.0319116C1.50188 -0.523438 0.58723 -0.523438 0.0318803 0.0319116L0.303834 0.303865ZM1.78528 0.303865L1.51333 0.575819L4.72622 3.78871L4.99817 3.51676L5.27012 3.2448L2.05723 0.0319116L1.78528 0.303865ZM4.99817 3.51676L5.27008 3.78875L8.48395 0.57586L8.21204 0.303865L7.94012 0.0318703L4.72626 3.24476L4.99817 3.51676Z" fill="white" mask="url(#path-1-inside-1_1678_4872)" />
          </svg>
        </button>
      </div>
      <div className='view-modal-content'>
        <div className="sidebar-header">
          <p className="back-button">
            View Record
          </p>
          {/* <div className='right-siede'>
            <Dropdown isOpen={dropdowns['client'] || false} toggle={() => toggleDropdownAction('client')} >
              <DropdownToggle caret>
                Actions
                <i className="icon">
                  <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                    <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                  </svg>
                </i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>View all properties</DropdownItem>
                <DropdownItem>View properties history</DropdownItem>
                <DropdownItem>View relation history</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div> */}
        </div>
        <div className="sidebar-content">
          <h4>{singlePageData?.title || dealData?.title || 'Loading...'}</h4>
          <p>Pipeline: <span>{singlePageData?.pipelineId?.name || dealData?.pipelineId?.name || 'N/A'}</span></p>
          <p>Stage: <span>{
            singlePageData?.stage
              ? singlePageData.stage.charAt(0).toUpperCase() + singlePageData.stage.slice(1)
              : dealData?.stage
                ? dealData.stage.charAt(0).toUpperCase() + dealData.stage.slice(1)
                : 'N/A'
          }</span></p>
          <div className='links-area'>
            <ul>
              <li>
                <button onClick={() => dispatch(setActiveActivityBox({ activityBox: 'call', associations: { deals: [dealData?._id] }, source: 'viewModal' }))}>
                  <i className='icon'>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.695 9.02366C10.695 9.18891 10.6583 9.35875 10.5802 9.52399C10.5022 9.68924 10.4012 9.84531 10.2681 9.9922C10.0432 10.2401 9.7953 10.4191 9.5153 10.5338C9.23989 10.6486 8.94152 10.7083 8.62021 10.7083C8.15201 10.7083 7.65167 10.5981 7.1238 10.3732C6.59592 10.1483 6.06805 9.84531 5.54476 9.46432C5.01689 9.07874 4.51655 8.65185 4.03917 8.17906C3.56638 7.70168 3.13949 7.20134 2.7585 6.67806C2.3821 6.15477 2.07915 5.63149 1.85882 5.11279C1.63849 4.58951 1.52832 4.08917 1.52832 3.61179C1.52832 3.29966 1.5834 3.00129 1.69357 2.72588C1.80373 2.44588 1.97816 2.18882 2.22144 1.95931C2.51522 1.67013 2.83653 1.52783 3.17621 1.52783C3.30474 1.52783 3.43326 1.55537 3.54802 1.61046C3.66736 1.66554 3.77294 1.74816 3.85556 1.86751L4.92049 3.36851C5.00312 3.48327 5.06279 3.58884 5.1041 3.68983C5.14541 3.78622 5.16836 3.88261 5.16836 3.96983C5.16836 4.07999 5.13623 4.19016 5.07197 4.29573C5.0123 4.40131 4.92508 4.51147 4.81492 4.62164L4.46606 4.98427C4.41557 5.03476 4.39262 5.09443 4.39262 5.16788C4.39262 5.2046 4.39721 5.23673 4.40639 5.27345C4.42016 5.31017 4.43393 5.33771 4.44311 5.36525C4.52573 5.51673 4.66803 5.71411 4.87 5.9528C5.07656 6.19149 5.29689 6.43478 5.53558 6.67806C5.78345 6.92134 6.02214 7.14626 6.26543 7.35282C6.50412 7.55479 6.7015 7.6925 6.85756 7.77512C6.88052 7.7843 6.90806 7.79807 6.94019 7.81184C6.97691 7.82561 7.01363 7.8302 7.05494 7.8302C7.13298 7.8302 7.19265 7.80266 7.24314 7.75217L7.592 7.4079C7.70676 7.29315 7.81692 7.20593 7.9225 7.15085C8.02807 7.08659 8.13365 7.05446 8.2484 7.05446C8.33561 7.05446 8.42742 7.07282 8.5284 7.11413C8.62939 7.15544 8.73496 7.21511 8.84972 7.29315L10.3691 8.37185C10.4884 8.45447 10.5711 8.55087 10.6215 8.66562C10.6674 8.78038 10.695 8.89513 10.695 9.02366Z" stroke="currentColor" stroke-width="0.763889" stroke-miterlimit="10" />
                    </svg>
                    <div className='overlaybox-tooltip'>
                      <p>Call</p>
                    </div>
                  </i>
                </button>
              </li>
              <li>
                <button onClick={() => dispatch(setActiveActivityBox({ activityBox: 'mail', associations: { deals: [dealData?._id] }, source: 'viewModal' }))}>
                  <i className='icon'>
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.1667 1.03711H3.05559C1.93057 1.03711 1.01855 1.94912 1.01855 3.07415V7.14822C1.01855 8.27324 1.93057 9.18526 3.05559 9.18526H9.1667C10.2917 9.18526 11.2037 8.27324 11.2037 7.14822V3.07415C11.2037 1.94912 10.2917 1.03711 9.1667 1.03711Z" stroke="currentColor" stroke-width="0.763889" />
                      <path d="M2.54639 3.5835L4.12267 4.93459C5.07158 5.74793 5.54603 6.15462 6.1112 6.15462C6.67638 6.15462 7.1508 5.74793 8.09971 4.93459L9.67602 3.5835" stroke="currentColor" stroke-width="0.763889" stroke-linejoin="round" />
                      <path d="M4.07416 5.11133L2.54639 6.63911" stroke="currentColor" stroke-width="0.763889" stroke-linejoin="round" />
                      <path d="M8.14795 5.11133L9.67573 6.63911" stroke="currentColor" stroke-width="0.763889" stroke-linejoin="round" />
                    </svg>
                    <div className='overlaybox-tooltip'>
                      <p>Send Email</p>
                    </div>
                  </i>
                </button>
              </li>
              <li>
                <button onClick={() => dispatch(setActiveActivityBox({ activityBox: 'note', associations: { deals: [dealData?._id] }, source: 'viewModal' }))}>
                  <i className='icon'>
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.04167 10.1666V9.70831C6.04167 7.97984 6.04167 7.11561 6.57865 6.57863C7.11559 6.04164 7.97987 6.04164 9.70834 6.04164H10.1667M4.66667 1H6.5C8.22847 1 9.09275 1 9.62969 1.53697C10.1667 2.07394 10.1667 2.93819 10.1667 4.66665V4.85342C10.1667 5.66412 10.1667 6.06947 10.0058 6.42774C9.84488 6.78602 9.54192 7.05534 8.936 7.59393L7.07971 9.24397C6.56848 9.69836 6.31287 9.9256 6.00088 10.0452L5.99148 10.0488C5.67881 10.1666 5.3368 10.1666 4.65286 10.1666C2.93781 10.1666 2.08029 10.1666 1.54467 9.63736L1.52933 9.622C1 9.08635 1 8.22886 1 6.51382V4.66665C1 2.93818 1 2.07394 1.53697 1.53697C2.07394 1 2.93818 1 4.66667 1Z" stroke="currentColor" stroke-width="0.763889" stroke-linejoin="round" />
                    </svg>
                    <div className='overlaybox-tooltip'>
                      <p>Add Note</p>
                    </div>
                  </i>
                </button>
              </li>
              <li>
                <button onClick={() => dispatch(setActiveActivityBox({ activityBox: 'schedule', associations: { deals: [dealData?._id] }, source: 'viewModal' }))}>
                  <i className='icon'>
                    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.07422 1.01904V2.54682" stroke="currentColor" stroke-width="0.763889" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7.14893 1.01904V2.54682" stroke="currentColor" stroke-width="0.763889" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M0.783203 4.62939H9.44061" stroke="currentColor" stroke-width="0.763889" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9.69499 4.32901V8.65772C9.69499 10.1855 8.9311 11.204 7.14869 11.204H3.07462C1.29221 11.204 0.52832 10.1855 0.52832 8.65772V4.32901C0.52832 2.80123 1.29221 1.78271 3.07462 1.78271H7.14869C8.9311 1.78271 9.69499 2.80123 9.69499 4.32901Z" stroke="currentColor" stroke-width="0.763889" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.10986 6.97705H5.11482" stroke="currentColor" stroke-width="1.14583" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3.2251 6.97705H3.23005" stroke="currentColor" stroke-width="1.14583" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3.2251 8.50439H3.23005" stroke="currentColor" stroke-width="1.14583" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div className='overlaybox-tooltip'>
                      <p>Add Meeting</p>
                    </div>
                  </i>
                </button>
              </li>
              <li>
                <button onClick={() => dispatch(setActiveActivityBox({ activityBox: 'task', associations: { deals: [dealData?._id] }, source: 'viewModal' }))}>
                  <i className='icon'>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.14655 11.5838H4.07322C2.21476 11.5838 1.14551 10.5146 1.14551 8.65609V3.56443C1.14551 1.70597 2.21476 0.636719 4.07322 0.636719H8.14655C10.005 0.636719 11.0743 1.70597 11.0743 3.56443V8.65609C11.0743 10.5146 10.005 11.5838 8.14655 11.5838ZM4.07322 1.40047C2.617 1.40047 1.90926 2.10821 1.90926 3.56443V8.65609C1.90926 10.1123 2.617 10.8201 4.07322 10.8201H8.14655C9.60277 10.8201 10.3105 10.1123 10.3105 8.65609V3.56443C10.3105 2.10821 9.60277 1.40047 8.14655 1.40047H4.07322Z" fill="currentColor" />
                      <path d="M9.41952 4.7096H8.40118C7.62725 4.7096 7.00098 4.08332 7.00098 3.30939V2.29105C7.00098 2.0823 7.17409 1.90918 7.38285 1.90918C7.59161 1.90918 7.76473 2.0823 7.76473 2.29105V3.30939C7.76473 3.66071 8.04986 3.94585 8.40118 3.94585H9.41952C9.62828 3.94585 9.80139 4.11896 9.80139 4.32772C9.80139 4.53648 9.62828 4.7096 9.41952 4.7096Z" fill="currentColor" />
                      <path d="M6.10995 7.00105H4.07328C3.86452 7.00105 3.69141 6.82794 3.69141 6.61918C3.69141 6.41042 3.86452 6.2373 4.07328 6.2373H6.10995C6.31871 6.2373 6.49182 6.41042 6.49182 6.61918C6.49182 6.82794 6.31871 7.00105 6.10995 7.00105Z" fill="currentColor" />
                      <path d="M8.14661 9.03768H4.07328C3.86452 9.03768 3.69141 8.86456 3.69141 8.6558C3.69141 8.44704 3.86452 8.27393 4.07328 8.27393H8.14661C8.35537 8.27393 8.52849 8.44704 8.52849 8.6558C8.52849 8.86456 8.35537 9.03768 8.14661 9.03768Z" fill="currentColor" />
                    </svg>
                    <div className='overlaybox-tooltip'>
                      <p>Add Task</p>
                    </div>
                  </i>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="quick-tabs single-deal-inner">
          <AppBar position='static'>
            <Tabs value={valueCustomVoiceTab} onChange={handleTabsSetCustomVoice} aria-label='simple tabs example'>
              <Tab label='About Deal' />
              <Tab label='Overview Deal' />
              <Tab label='All Activities' />
            </Tabs>
          </AppBar>

          <TabPanel value={valueCustomVoiceTab} index={0}>
            <div className="sidebar-accordian ">
              <Accordion allowZeroExpanded preExpanded={['a']}>
                <AccordionItem uuid="a" >
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      About this deal
                      <div className='right-siede'>
                        <Dropdown isOpen={dropdowns['action'] || false} toggle={() => toggleDropdownAction('action')} >
                          <DropdownToggle caret>
                            Actions
                            <i className="icon">
                              <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                                <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                              </svg>
                            </i>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>View all properties</DropdownItem>
                            <DropdownItem>View properties history</DropdownItem>
                            <DropdownItem>View relation history</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="accordion-content">
                      {renderAboutProperties()}
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem className='upcoming-box' uuid="b">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <p>Upcoming activities</p>
                      <div className='right-siede'>
                        <Dropdown isOpen={dropdowns['collapseUpcoming'] || false} toggle={() => toggleDropdownAction('collapseUpcoming')} >
                          <DropdownToggle caret>
                            Expand all
                            <i className="icon">
                              <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                                <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                              </svg>
                            </i>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Collapse all </DropdownItem>
                            <DropdownItem>Expand all </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    {loading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                        <TableAnimationFiles />
                      </div>
                    ) : singlePageData?.activitiesGrouped && singlePageData.activitiesGrouped.length > 0 ? (
                      <div className="main-side-accordian overview-tab">
                        {(() => {
                          // Get all activities and filter for upcoming ones
                          const allActivities = [];
                          singlePageData.activitiesGrouped.forEach(group => {
                            if (group?.activities) {
                              group.activities.forEach(activity => {
                                allActivities.push({ ...activity, group });
                              });
                            }
                          });

                          // Filter for upcoming activities (status not completed)
                          const upcomingActivities = allActivities.filter(activity =>
                            activity.status !== 'completed' && activity.type !== 'note'
                          );

                          if (upcomingActivities.length === 0) {
                            return (
                              <div style={{ textAlign: 'center', padding: '20px', color: '#89868D' }}>
                                <p>No upcoming activities</p>
                              </div>
                            );
                          }

                          // Pagination
                          const totalPages = Math.ceil(upcomingActivities.length / itemsPerPage);
                          const startIndex = (upcomingPage - 1) * itemsPerPage;
                          const paginatedActivities = upcomingActivities.slice(startIndex, startIndex + itemsPerPage);

                          return (
                            <>
                              <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                                {paginatedActivities.map((activity, index) => (
                                  <ActivityCard
                                    key={`upcoming-${activity._id}-${index}`}
                                    singlePageData={singlePageData}
                                    activity={activity}
                                    group={activity.group}
                                    index={startIndex + index}
                                  />
                                ))}
                              </Accordion>
                              {totalPages > 1 && (
                                <ul className='pagination-modal'>
                                  <li><button className='paginantion-arrow left-arrow' onClick={() => setUpcomingPage(p => Math.max(1, p - 1))} disabled={upcomingPage === 1}><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_1753_2254)"><path d="M8.87555 9.5247L6.35655 7.0002L8.87555 4.4757L8.10005 3.7002L4.80005 7.0002L8.10005 10.3002L8.87555 9.5247Z" fill="var(--primary-color)" /></g></svg></button></li>
                                  {[...Array(Math.min(5, totalPages))].map((_, i) => {
                                    const page = i + 1;
                                    return <li key={page}><button className={upcomingPage === page ? 'active' : ''} onClick={() => setUpcomingPage(page)}>{page}</button></li>;
                                  })}
                                  <li><button className='paginantion-arrow right-arrow' onClick={() => setUpcomingPage(p => Math.min(totalPages, p + 1))} disabled={upcomingPage === totalPages}><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_1753_2732)"><path d="M5.12451 9.5247L7.64351 7.0002L5.12451 4.4757L5.90001 3.7002L9.20001 7.0002L5.90001 10.3002L5.12451 9.5247Z" fill="var(--primary-color)" /></g></svg></button></li>
                                </ul>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#89868D' }}>
                        <p>No upcoming activities</p>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>

              <Accordion allowZeroExpanded preExpanded={['c']}>
                <AccordionItem className='upcoming-box' uuid="c">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <p>Recent activities</p>
                      <div className='right-siede'>
                        <Dropdown isOpen={dropdowns['collapseRecent'] || false} toggle={() => toggleDropdownAction('collapseRecent')} >
                          <DropdownToggle caret>
                            Expand all
                            <i className="icon">
                              <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                                <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                              </svg>
                            </i>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Collapse all </DropdownItem>
                            <DropdownItem>Expand all </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    {loading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                        <TableAnimationFiles />
                      </div>
                    ) : singlePageData?.activitiesGrouped && singlePageData.activitiesGrouped.length > 0 ? (
                      <div className="main-side-accordian overview-tab">
                        {(() => {
                          // Get all activities
                          const allActivities = [];
                          singlePageData.activitiesGrouped.forEach(group => {
                            if (group?.activities) group.activities.forEach(activity => { allActivities.push({ ...activity, group }); });
                          });

                          // Get recent activities (sorted by date, limit to 3)
                          const recentActivities = allActivities.sort((a, b) => new Date(b.createdAt || b.updatedAt) - new Date(a.createdAt || a.updatedAt)).slice(0, 3);

                          if (recentActivities.length === 0) {
                            return (
                              <div style={{ textAlign: 'center', padding: '20px', color: '#89868D' }}>
                                <p>No recent activities</p>
                              </div>
                            );
                          }

                          return (
                            <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                              {recentActivities.map((activity, index) => (
                                <ActivityCard
                                  key={`recent-${activity._id}-${index}`}
                                  singlePageData={singlePageData}
                                  activity={activity}
                                  group={activity.group}
                                  index={index}
                                />
                              ))}
                            </Accordion>
                          );
                        })()}
                      </div>
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#89868D' }}>
                        <p>No recent activities</p>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            </div>
          </TabPanel>

          <TabPanel value={valueCustomVoiceTab} index={1}>
            <div className="sidebar-accordian">
              {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                  <TableAnimationFiles />
                </div>
              ) : singlePageData?.activitiesGrouped && singlePageData.activitiesGrouped.length > 0 ? (
                (() => {
                  // Get all activities
                  const allActivities = [];
                  singlePageData.activitiesGrouped.forEach(group => {
                    if (group?.activities) {
                      group.activities.forEach(activity => {
                        allActivities.push({ ...activity, group });
                      });
                    }
                  });

                  // Get recent activities (sorted by date, limit to 5)
                  const recentActivities = allActivities
                    .sort((a, b) => new Date(b.createdAt || b.updatedAt) - new Date(a.createdAt || a.updatedAt))
                    .slice(0, 5);

                  if (recentActivities.length === 0) {
                    return (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#89868D' }}>
                        <p>No recent activities</p>
                      </div>
                    );
                  }

                  return (
                    <div className="main-side-accordian overview-tab">
                      <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                        {recentActivities.map((activity, index) => (
                          <ActivityCard
                            key={`overview-${activity._id}-${index}`}
                            singlePageData={singlePageData}
                            activity={activity}
                            group={activity.group}
                            index={index}
                          />
                        ))}
                      </Accordion>
                    </div>
                  );
                })()
              ) : (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: '#89868D' }}>
                  <p>No activities available</p>
                </div>
              )}
            </div>
          </TabPanel>

          <TabPanel value={valueCustomVoiceTab} index={2}>
            <div className={`deal-main-content`}>
              <div className="deal-activities">
                <div className={`tabs-content tab-single-page`}>
                  {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                      <TableAnimationFiles />
                    </div>
                  ) : singlePageData ? (
                    <AllActivities
                      selectedTab="all"
                      singlePageData={singlePageData}
                      searchText={''}
                    />
                  ) : (
                    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#89868D' }}>
                      <p>No activities available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </TabPanel>
        </div>

      </div>
    </aside>
  );
};

export default ViewModal;
